module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/can-vux-used-in-weapp-40.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/can-vux-used-in-weapp.md
// module id = 742
// module chunks = 462